<script>
import transitionFade from '../transition/fade';
import shadowBox from '../shadow';
export default {
    props: {
        status: {
            type: Boolean,
            default: false,
        },
        params: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            innerStatus: this.status,
            zIndex: 120
        };
    },
    methods: {
        confirm() {
            this.innerStatus = false;
            this.$emit('update:status', this.innerStatus);
        },
        show() {
            this.innerStatus = true;
        },
        hide() {
            this.innerStatus = false;
        }
    },
    watch: {
        innerStatus() {
            if (this.innerStatus) {
                this.$emit('show');
            } else {
                this.$emit('hide');
            }
        }
    },
    components: {
        transitionFade,
        shadowBox
    }
}
</script>

<template>
    <shadow-box 
        :status="innerStatus"
        :zIndex="zIndex"
    >
        <transition-fade>
            <div v-if="innerStatus" class="alert-container">
                <div class="alert-inner">
                    <div class="header" v-if="params.title">{{params.title}}</div>
                    <div class="content">
                        <slot>{{params.content}}</slot>
                    </div>
                    <div class="button" @click="confirm">{{params.buttonText || '确认'}}</div>
                </div>
            </div>
        </transition-fade>
    </shadow-box>
</template>

<style lang="stylus" scoped>
.alert-container
    display flex
    justify-content center
    align-items center
    width 100%;
    height 100%
.alert-inner
    display flex
    flex-direction column
    margin auto
    width 16rem
    background-color #fff
    border-radius 0.4rem
.header
    font-size 0.85rem
    height 2.23rem
    line-height 2.23rem
    text-align center
    border-bottom 0.054rem solid #eee;
    color #666
.content
    flex 1
    padding 1.5rem 1rem
    line-height 1.2
    text-align center
    font-size 0.85rem
.button
    font-size 0.85rem
    height 2.23rem
    line-height 2.23rem
    text-align center
    border-top 0.054rem solid #eee;
    color #4480f0
</style>